import React from 'react'
import { IReportData } from '../../helpers/Interfaces';
import Loading from '../Loading/Loading';

type ReportViewProps = {
    report: IReportData;
    loading: boolean;
}

function ReportView(props: Readonly<ReportViewProps>) {
    return (
        <div className="view-document-body report-template-content">
            <div className="report-content">
                {!props.loading
                    ? (<div className="report-pdf-view">
                        {props.report?.pdf?.link
                            ? (<iframe height={'98%'} width={'98%'} src={`${props.report?.pdf?.link}#toolbar=0`} title="Embedded PDF" />)
                            : <></>
                        }
                    </div>)
                    : (<div className="loading-content"><Loading color="black" /></div>)
                }
            </div>
        </div>
    )
}

export default ReportView